function FooterPayment() {
  return (
    <footer className="bg-white pt-10 pb-[3.125rem] mx-[89px] border-t border-dashed border-[#dcdcdc]">
      <div className="max-w-[76.875rem] mx-auto text-[0.688rem] leading-4">
        <div className="text-[#808089] mb-1">
          Bằng việc tiến hành Đặt Mua, bạn đồng ý với các Điều kiện Giao dịch
          chung:
        </div>
        <div>
          <span className="text-black">Quy chế hoạt động</span>
          <span className="border border-[#dddde3] mx-3"></span>
          <span className="text-black">Chính sách giải quyết khiếu nại</span>
          <span className="border border-[#dddde3] mx-3"></span>
          <span className="text-black">Chính sách bảo hành</span>
          <span className="border border-[#dddde3] mx-3"></span>
          <span className="text-black">Chính sách bảo mật thanh toán</span>
          <span className="border border-[#dddde3] mx-3"></span>
          <span className="text-black">
            Chính sách bảo mật thông tin cá nhân
          </span>
        </div>
        <p className="text-[#808089] mt-5">
          © 2022 - Bản quyền của nhóm 7 Reactjs
        </p>
      </div>
    </footer>
  );
}

export default FooterPayment;
